export class CachingRequests {
  static readonly type = 'DebugCachingRequests';
  constructor(public request: any) {}
}
